import request from "@/utils/request";

// 获取组织架构
export function queryOrganization() {
  return request({
    url: "/org/tree",
    method: "get",
  });
}

// 获取人员信息  公司 0  部门 3
export function queryUserList(type) {
  return request({
    url: `/auth/user/getUserByUserCodeFeign?type=${type}`,
    method: "get",
  });
}
